import { ActivityEntityName, ActivityTag, Attachment } from '@jms/model';

export enum FilesDisplayMode {
    Full = 'Full',
    Sidebar = 'Sidebar',
    Picker = 'Picker',
    Claims = 'Claims'
}

export enum AllowedPickType {
    Files = 'File',
    Images = 'Image',
    Forms = 'Form'
}

export interface FilesContext {
    entity: ActivityEntityName;
    entityId: string;
    entityName: string;
    activityTags: ActivityTag[];
    displayMode: FilesDisplayMode;
    timezone?: string;
    readonly?: boolean;
    allowTypes?: AllowedPickType[];
    disableSharing?: boolean;
    copy?: (attachment: Attachment) => Promise<Attachment>
}